import { type FC } from 'react';
import {
  TextInputWithGeolocationComponent, type TextInputWithGeolocationProps,
} from '~/_shared/components/textInputWithGeolocation/textInputWithGeolocation.compontent';
import { useTranslation } from '../../../../_shared/utils/hooks';
import { ProximityPanelInputLabelComponent } from './proximityPanelInputLabel.component';

export const ProximityPanelGeolocationInputComponent: FC<TextInputWithGeolocationProps> = props => {
  const [t] = useTranslation();

  return (
    <>
      <ProximityPanelInputLabelComponent>{t('Starting Location')}</ProximityPanelInputLabelComponent>
      <TextInputWithGeolocationComponent {...props} />
    </>
  );
};
